module.exports = __webpack_public_path__ + "img/2_проблемы фон_2.e42b9409.png";